module.exports = __webpack_public_path__ + "static/ajaegbe-c5abb367123d8c0c432d35aa71af1125.png";